import { isEqual } from 'date-fns';

/**
 * This functions appends which date was changed in the most recent edit from the app.
 * We _need_ to do this in order for the administrators to know if the user expects a destination or a pickup time.
 * And since there currently is no way of setting this in the Frogne web, we need to append it into the operatorComment.
 */
export function appendCommentIfDateHasChanged(
  value: { type: 'pickup' | 'destination'; date: Date },
  initialPickup: string | undefined,
  initialDropoff: string | undefined,
  comment: string | undefined
) {
  if (
    (value.type === 'pickup' &&
      !isEqual(value.date, new Date(initialPickup ?? 0))) ||
    (value.type === 'destination' &&
      !isEqual(value.date, new Date(initialDropoff ?? 0)))
  ) {
    const prefix = value.type === 'pickup' ? 'Changed pickup time.' : 'Changed dropoff time.';
    return comment ? `${prefix}\n${comment}` : prefix;
  }
  return comment;
}
